@if(data.length > 0) {
<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
	<tr>
		<th>Staff</th>
		<th>Engaged</th>
		<th>Assigned</th>
	</tr>
	@for(row of data; track row.staffId) {
	<tr>
		<td>{{row.staffName}}</td>
		<td>{{row.engagedCount}}</td>
		<td>{{row.assignedCount}}</td>
	</tr>
	}
</table>
}
@else {
<div class="text-muted">No staff engagement data available</div>
}